var app = app ||  {};
app.faturamento = app.faturamento || {};

;(function(namespace, $){

  var Faturamento = function() {

    function initializeValidation() {
      var validate_form = new lcssafira.form.ValidateForm('form-faturamento');
    }

    function BuscaCliente() {
      $('#form-busca-cliente').submit(function(event) {
        event.preventDefault();
        var data = $(this).serialize();
        app.datatable.initDataTable(true, false, '?' + data, 'cliente', '/cliente/consultar');
      });
    }

    function listenerCheckTipo() {
      $('#tipo').on('switchChange.bootstrapSwitch', function(event, state) {
          showInputs(state);
      });
    }

    function showInputs(state) {
      
      if(state) {
        $('#col-mes').addClass('hide');
        $('#mes').removeClass('required');
      }
      else {
        $('#col-mes').removeClass('hide');
        $('#mes').addClass('required');
      }
    }

    // function abreCliente() {
    //   $('table').on('click', '.cliente-col', function(event) {
    //     event.preventDefault();
    //     id_cliente = $(this).parents('tr').find('.cod').text();
    //     app.ajaxrequest.initialize('/cliente/consultar/' + id_cliente, 'get', 'json', '', app.cliente.responseCliente);
    //   });
    // }

    // function responseCliente(data) {
    //   var holder_contatos;

    //   holder_contatos = $('#holder-contatos');
    //   holder_contatos.html('');

    //   $('.bd-holder').each(function(index, el) {
    //     column = $(this).attr('data-column');

    //     if(data[0][column] == '' || data[0][column] == null)
    //       $(el).text('n/d');
    //     else
    //       $(el).html(data[0][column]);
    //   });

    //   $.each(data[0]['contatos_cliente'], function(index, val) {
    //      holder_contatos.append(
    //       '<span class="block small">Contato: ' + val.nome_contato_cliente + '</span>' + 
    //       '<span class="block small">Tel.: ' + val.tel_contato_cliente + '</span>' + 
    //       '<span class="block small">E-mail: ' + val.email_contato_cliente + '</span>'
    //       );
    //   });

    //   $('#modal-cliente').modal();
    // }

    function _construct() {
      initializeValidation();
      listenerCheckTipo();
      showInputs(false);
      

      // app.datatable.initDataTable(false, true, '', 'cliente', '/cliente/consultar');
      var message = "Tem certeza que deseja excluir o faturamento?";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-fat', message);
    }

    // namespace.responseCliente = responseCliente;
    _construct();

  };

  var main = new Faturamento();

})(app.faturamento, jQuery);


